module.exports = __webpack_public_path__ + "media/images/subs_logo_reading_club-77657ef3c3b0d8efe3d307bbc6627fd6.png";